export enum BROWSER_ENUM {
    EDGE = 'Edge',
    INTERNET_EXPLORER = 'Internet Explorer',
    FIRE_FOX = 'Firefox',
    OPERA = 'Opera',
    UC_BROWSER = 'UC Browser',
    SAMSUNG_BROWSER = 'Samsung Browser',
    CHROME = 'Chrome',
    SAFARI = 'Safari',
    UNKNOWN = 'Unknown',
}

class BrowserService {
    private static serviceInstance: BrowserService;

    public static get instance() {
        if (!this.serviceInstance) {
            this.serviceInstance = new this();
        }
        return this.serviceInstance;
    }

    private testUserAgent(regexp: RegExp): boolean {
        return regexp.test(window.navigator.userAgent);
    }

    public getBrowser(): BROWSER_ENUM {
        switch (true) {
            case this.testUserAgent(/edg/i): return BROWSER_ENUM.EDGE;
            case this.testUserAgent(/trident/i): return BROWSER_ENUM.INTERNET_EXPLORER;
            case this.testUserAgent(/firefox|fxios/i): return BROWSER_ENUM.FIRE_FOX;
            case this.testUserAgent(/opr\//i): return BROWSER_ENUM.OPERA;
            case this.testUserAgent(/ucbrowser/i): return BROWSER_ENUM.UC_BROWSER;
            case this.testUserAgent(/samsungbrowser/i): return BROWSER_ENUM.SAMSUNG_BROWSER;
            case this.testUserAgent(/chrome|chromium|crios/i): return BROWSER_ENUM.CHROME;
            case this.testUserAgent(/safari/i): return BROWSER_ENUM.SAFARI;
            default: return BROWSER_ENUM.UNKNOWN;
        }
    }
}

export default BrowserService.instance;
